export default "__VITE_ASSET__KNlpVNVA__"